import type { ApiModuleEndpoints } from '../types'

export const productApiEndpoints = {
  list: {
    method: 'GET',
    path: '/products',
    requiresAuth: true,
  },
  options: {
    method: 'GET',
    path: '/products/options',
    requiresAuth: true,
  },
  detail: {
    method: 'GET',
    path: '/products/:id',
    requiresAuth: true,
  },
  create: {
    method: 'POST',
    path: '/products',
    requiresAuth: true,
  },
  importTemplate: {
    method: 'GET',
    path: '/products/import-template',
    requiresAuth: true,
  },
  importCatalogs: {
    method: 'GET',
    path: '/products/import-catalogs',
    requiresAuth: true,
  },
  update: {
    method: 'PUT',
    path: '/products/:id',
    requiresAuth: true,
  },
  delete: {
    method: 'DELETE',
    path: '/products/:id',
    requiresAuth: true,
  },
  variants: {
    method: 'GET',
    path: '/products/:id/variants',
    requiresAuth: true,
  },
  createVariant: {
    method: 'POST',
    path: '/products/:id/variants',
    requiresAuth: true,
  },
  generateVariants: {
    method: 'POST',
    path: '/products/:id/variants/generate',
    requiresAuth: true,
  },
  bulkUpdateVariants: {
    method: 'PUT',
    path: '/products/:id/variants/bulk',
    requiresAuth: true,
  },
  updateVariant: {
    method: 'PATCH',
    path: '/products/:id/variants/:variantId',
    requiresAuth: true,
  },
  imagePresign: {
    method: 'POST',
    path: '/products/:id/images/presign',
    requiresAuth: true,
  },
  imageConfirm: {
    method: 'POST',
    path: '/products/:id/images/:imageId/confirm',
    requiresAuth: true,
  },
  imageList: {
    method: 'GET',
    path: '/products/:id/images',
    requiresAuth: true,
  },
  imageDelete: {
    method: 'DELETE',
    path: '/products/:id/images/:imageId',
    requiresAuth: true,
  },
  groups: {
    method: 'GET',
    path: '/products/groups',
    requiresAuth: true,
  },
  productGroups: {
    method: 'GET',
    path: '/products/groups',
    requiresAuth: true,
  },
  productGroupDetail: {
    method: 'GET',
    path: '/products/groups/:id',
    requiresAuth: true,
  },
  createGroup: {
    method: 'POST',
    path: '/products/groups',
    requiresAuth: true,
  },
  createProductGroup: {
    method: 'POST',
    path: '/products/groups',
    requiresAuth: true,
  },
  updateGroup: {
    method: 'PUT',
    path: '/products/groups/:id',
    requiresAuth: true,
  },
  updateProductGroup: {
    method: 'PUT',
    path: '/products/groups/:id',
    requiresAuth: true,
  },
  deleteGroup: {
    method: 'DELETE',
    path: '/products/groups/:id',
    requiresAuth: true,
  },
  deleteProductGroup: {
    method: 'DELETE',
    path: '/products/groups/:id',
    requiresAuth: true,
  },
  brands: {
    method: 'GET',
    path: '/products/brands',
    requiresAuth: true,
  },
  brandOptions: {
    method: 'GET',
    path: '/products/brands/options',
    requiresAuth: true,
  },
  brandDetail: {
    method: 'GET',
    path: '/products/brands/:id',
    requiresAuth: true,
  },
  createBrand: {
    method: 'POST',
    path: '/products/brands',
    requiresAuth: true,
  },
  updateBrand: {
    method: 'PUT',
    path: '/products/brands/:id',
    requiresAuth: true,
  },
  deleteBrand: {
    method: 'DELETE',
    path: '/products/brands/:id',
    requiresAuth: true,
  },
  units: {
    method: 'GET',
    path: '/products/units',
    requiresAuth: true,
  },
  groupOptions: {
    method: 'GET',
    path: '/products/groups/options',
    requiresAuth: true,
  },
  unitOptions: {
    method: 'GET',
    path: '/products/units/options',
    requiresAuth: true,
  },
  unitDetail: {
    method: 'GET',
    path: '/products/units/:id',
    requiresAuth: true,
  },
  createUnit: {
    method: 'POST',
    path: '/products/units',
    requiresAuth: true,
  },
  updateUnit: {
    method: 'PUT',
    path: '/products/units/:id',
    requiresAuth: true,
  },
  deleteUnit: {
    method: 'DELETE',
    path: '/products/units/:id',
    requiresAuth: true,
  },
  locations: {
    method: 'GET',
    path: '/products/locations',
    requiresAuth: true,
  },
  locationOptions: {
    method: 'GET',
    path: '/products/locations/options',
    requiresAuth: true,
  },
  locationTree: {
    method: 'GET',
    path: '/products/locations/tree',
    requiresAuth: true,
  },
  createLocation: {
    method: 'POST',
    path: '/products/locations',
    requiresAuth: true,
  },
  updateLocation: {
    method: 'PUT',
    path: '/products/locations/:id',
    requiresAuth: true,
  },
  deleteLocation: {
    method: 'DELETE',
    path: '/products/locations/:id',
    requiresAuth: true,
  },
} as const satisfies ApiModuleEndpoints
